import { connect } from 'react-redux'

import Main from './main'

import { goToStep, nextStep } from '../../../reducers/captive'
import { toggleModal } from '../../../reducers/modals'

export default connect((state) => state, { goToStep, nextStep, toggleModal })(Main)
